import React from 'react'
import { Form, Button } from 'react-bootstrap'
import InputMask from "react-input-mask";
import styled from 'styled-components'
import { formatDocument, formatPhoneNumber } from '../../../../utils';

const Label = styled.p`
font-family: roboto;
font-size: 1.1em;
`

import { mapTest } from '../../products/map.test';
export default class Filter extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            params: {
                end_count: 10
            },
            fields: [
                {
                    "name": "name",
                    "label": "Nome",
                    "type": "text"
                },
                {
                    "name": "cpf_cnpj",
                    "label": "CPF/CNPJ",
                    "type": "text",
                    "maxLength": 14
                },
                {
                    "name": "email",
                    "label": "E-mail",
                    "type": "email"
                },
                {
                    "name": "phone_number",
                    "label": "Telefone",
                    "type": "text",
                    "mask": "(99) 99999-9999"
                },
                {
                    "name": "end_count",
                    "label": "Exibir até:",
                    "type": "select",
                    "options": [10, 20, 30, 50, 100, 200, 300, 500, 1000]
                },

            ],
            searchResult: [],
            loading: false,
            lastFieldUsed: ""
        }
        this.onChange = this.onChange.bind(this)
        this.filter = this.filter.bind(this)
    }
    onChange(e) {
        const { params } = this.state
        let { name: key, value } = e.target
        if (key === "phone_number" || key === "cpf_cnpj") {
            value = value.replace(/\D+/g, "")
        }
        params[key] = value
        this.setState({ params, lastFieldUsed: key })
    }
    filter() {
        this.setState({ loading: true, searchResult: [] })
        window.clientAPI
            .getClients(this.state.params)
            .then(searchResult => {
                this.setState({ searchResult, loading: false })
                this.handleSetFocusOnLastFieldUsed()
            })
            .catch(error => {
                this.setState({ loading: false })
                this.handleSetFocusOnLastFieldUsed()
            })
    }
    handleSetFocusOnLastFieldUsed() {
        if (this.state.lastFieldUsed) {
            try {
                document.querySelector(`[name="${this.state.lastFieldUsed}"]`).focus()
            } catch (error) { }
        }
    }
    onRowClick(item) {
        this.props.onClick(item)
        this.setState({ searchResult: [] })
    }
    render() {
        return <React.Fragment>
            {
                this.props.showTitle
                    ? <div className="row">
                        <div className="col-12">
                            <Label>
                                Pesquisar Cliente
                            </Label>
                        </div>
                    </div>
                    : <span />
            }
            <div className="row">
                {
                    this.state.fields.map((field, index) => {
                        const key = `clients-list-index-${index}`
                        if (field.type === "select") {
                            return <div className="col-md-6 col-xs-12" key={key}>
                                <Form.Group>
                                    <Form.Label>{field.label}</Form.Label>
                                    <Form.Control
                                        onChange={this.onChange}
                                        name="end_count"
                                        as="select">
                                        {
                                            field.options.map((option, index) => {
                                                return <option
                                                    key={index}
                                                    value={option}>{option} resultados</option>
                                            })
                                        }
                                    </Form.Control>
                                </Form.Group>
                            </div>
                        }
                        return <div className="col-md-6 col-xs-12" key={key}>
                            <Form.Group>
                                <Form.Label>{field.label}</Form.Label>
                                <InputMask
                                    maxLength={field.maxLength}
                                    disabled={this.state.loading}
                                    mask={field.mask}
                                    className="form-control"
                                    name={field.name}
                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            this.filter()
                                        }
                                    }}
                                    value={this.state.params[field.name]}
                                    onChange={this.onChange}
                                />
                            </Form.Group>
                        </div>
                    })
                }

                <div className="col-12 text-right">
                    <Button
                        onClick={this.filter}
                        disabled={this.state.loading}
                        id={mapTest.emitNfe.clientSearchButton} >
                        {this.state.loading ? "Pesquisando ... " : "Pesquisar Cliente"}
                        {
                            this.state.loading
                                ? <span className='fas fa-spinner fa-spin ml-3' />
                                : <span className='fas fa-search ml-3' />
                        }
                    </Button>
                </div>
                <div className={`${this.state.searchResult.length ? "col-12" : "d-none"}`}>
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>CPF/CNPJ</th>
                                    <th>E-mail</th>
                                    <th>Telefone</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.searchResult.map((result, index) => {
                                        if (result.company) {
                                            result.cpf_cnpj = result.company.cnpj
                                        } else {
                                            result.cpf_cnpj = result.individual.cpf
                                        }
                                        result.cpf_cnpj = formatDocument(result.cpf_cnpj)
                                        result.phone_number = formatPhoneNumber(result.phone_number)

                                        return <tr
                                            style={{ cursor: 'pointer' }}
                                            title={result.name}
                                            onClick={() => this.onRowClick(result)} key={index}>
                                            <td>{result.name}</td>
                                            <td>{result.cpf_cnpj}</td>
                                            <td>{result.email}</td>
                                            <td>{result.phone_number}</td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </React.Fragment>
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/clients/components/filter.jsx